import React, { createContext } from 'react';

import useScoringReducer from './useScoringReducer';

const ScoringStateContext = createContext();
const ScoringUpdaterContext = createContext();

function ScoringProvider({ children }) {
  const [scoring, dispatch] = useScoringReducer();

  return (
    <ScoringStateContext.Provider value={scoring}>
      <ScoringUpdaterContext.Provider value={dispatch}>
        {children}
      </ScoringUpdaterContext.Provider>
    </ScoringStateContext.Provider>
  );
}

function useScoringProviderState() {
  const scoringState = React.useContext(ScoringStateContext);
  if (scoringState === undefined) {
    throw new Error(
      'useScoringProviderState must be used within a ScoringProvider',
    );
  }
  return scoringState;
}

function useScoringProviderUpdater() {
  const dispatch = React.useContext(ScoringUpdaterContext);
  if (dispatch === undefined) {
    throw new Error(
      'useScoringProviderUpdater must be used within a ScoringProvider',
    );
  }
  return dispatch;
}

const useScoring = () => [
  useScoringProviderState(),
  useScoringProviderUpdater(),
];

export { ScoringProvider, useScoring };
